import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import linkifyRegex from "remark-linkify-regex";

import { getMessageClassName } from "shared/functions";

import renderers from "./renderers";
import { linkRegexp } from "./constants";
import { transformLinkUri } from "./functions";

import "./index.css";

const remarkPlugins = [linkifyRegex(linkRegexp), remarkGfm];

type Props = {
  message: string;
  isSent: boolean;
};

function MessageWithLinks(props: Props) {
  const { message, isSent } = props;

  const messageClassName = getMessageClassName(isSent);

  return (
    <div
      className="prose prose-sm
        prose-headings:mb-1 prose-headings:mt-2 prose-headings:text-lg prose-headings:font-medium
        prose-p:my-1 prose-strong:font-medium prose-ul:my-1 prose-li:my-0
        prose-table:break-words prose-th:align-top"
    >
      <div className={messageClassName}>
        <ReactMarkdown
          remarkPlugins={remarkPlugins}
          transformLinkUri={transformLinkUri}
          components={renderers}
        >
          {message}
        </ReactMarkdown>
      </div>
    </div>
  );
}

export default MessageWithLinks;
